import { render } from "./closed.vue?vue&type=template&id=afcc3c08"
import script from "./closed.vue?vue&type=script&lang=js"
export * from "./closed.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__